type ClientLogValue = string | number | boolean | null | readonly (string | number | boolean | null)[];
type ClientLogFields = Record<string, ClientLogValue | undefined>;

function write(level: "info" | "warn" | "error", event: string, fields: ClientLogFields): void {
  if (typeof window === "undefined") return;
  console[level](JSON.stringify({ source: "craftoff_client", event, ...fields }));
}

export function clientLog(event: string, fields: ClientLogFields = {}): void {
  write("info", event, fields);
}

export function clientWarn(event: string, fields: ClientLogFields = {}): void {
  write("warn", event, fields);
}

export function clientError(event: string, fields: ClientLogFields = {}): void {
  write("error", event, fields);
}
